import { render, staticRenderFns } from "./totalmeterinfo.vue?vue&type=template&id=24b253ae&"
import script from "./totalmeterinfo.vue?vue&type=script&lang=ts&"
export * from "./totalmeterinfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "totalmeterinfo.vue"
export default component.exports